"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "light";
const brand = "#A29263";
const headerTextColor = "#A29263";
const mainInfoLandscape = brand;
const mainInfoPortrait = brand;
const headerBackgroundColor = "#DCE8F4";
const fontFamily = `
    html {
        font-family: "Tahoma", sans-serif;
    }
`;
exports.default = {
    brand,
    headerBackgroundColor,
    fontFamily,
    style,
    headerTextColor,
    mainInfoLandscape,
    mainInfoPortrait,
};
